export function hrefOpen(url) {
    var link = document.createElement('a')
    link.target = '_blank'
    link.href = url
    link.id = 'href'
    document.body.appendChild(link)
    link.click()
  }